import { useEffect } from "react"

export function useTableScroll(footer) {
    useEffect(() => {
        if (!footer.current) return

        const body = document.body
        const footerEl = footer.current

        const bodyPosition = body.style.position
        const bodyOverflow = body.style.overflow
        const footerPosition = footerEl.style.position
        const footerBottom = footerEl.style.bottom

        body.style.position = "relative"
        // Version 3.0 deaktiviert
        //body.style.overflow = 'scroll';
        footerEl.style.position = "fixed"
        footerEl.style.bottom = "0"

        return function cleanUp() {
            // Revert changes.
            body.style.position = bodyPosition
            body.style.overflow = bodyOverflow
            footerEl.style.position = footerPosition
            footerEl.style.overflow = footerBottom
        }
    }, [footer])
}
